var _defs, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNowmyplaceIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "nowmyplace-icon",
    className: "icona-svg",
    "data-name": "nowmyplace icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.191,
    height: 50.8,
    viewBox: "0 0 33.191 50.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #FFFFFF;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_202",
    "data-name": "Tracciato 202",
    className: "cls-1",
    d: "M169,224.751a11.9,11.9,0,0,0,4.211-.767,11.808,11.808,0,0,0-10.972-7.67,11.439,11.439,0,0,0-4.345.858A11.929,11.929,0,0,0,169,224.751Z",
    transform: "translate(-147.736 -191.776)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_203",
    "data-name": "Tracciato 203",
    className: "cls-1",
    d: "M154.121,164.574c0-.042,0-.084,0-.126a9.121,9.121,0,1,0-9.863,9.088A11.937,11.937,0,0,1,154.121,164.574Z",
    transform: "translate(-134.581 -155.328)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_204",
    "data-name": "Tracciato 204",
    className: "cls-1",
    d: "M179.709,189.923a11.926,11.926,0,0,0-13.652-11.8,9.119,9.119,0,0,1-9.117,8.995c-.25,0-.5-.013-.742-.033a11.864,11.864,0,0,0-.238,4.4,14.572,14.572,0,0,1,18.576,8.268A11.913,11.913,0,0,0,179.709,189.923Z",
    transform: "translate(-146.517 -168.875)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_205",
    "data-name": "Tracciato 205",
    className: "cls-1",
    d: "M158.867,225.207a11.7,11.7,0,1,1-16.062-10.9,11.858,11.858,0,0,1-.716-2.786A14.549,14.549,0,1,0,161.7,225.207a14.681,14.681,0,0,0-1.03-5.418,11.909,11.909,0,0,1-2.543,1.33A11.6,11.6,0,0,1,158.867,225.207Z",
    transform: "translate(-132.646 -188.912)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNowmyplaceIcon);
export default __webpack_public_path__ + "static/media/nowmyplace-icon.27109e5cff2c065895c4cbf487b4ace8.svg";
export { ForwardRef as ReactComponent };